export default {
  'notifications.title': 'Notifications',
  'notifications.drawerTitle': 'NOTIFICATIONS',
  'notifications.empty': 'You have no notifications',
  'notifications.unread': 'unread',
  'notifications.markAsRead': 'Mark as read',
  'notifications.markAllAsRead': 'Mark all as read',
  'notifications.markAsReadShort': 'Mark as read',
  'notifications.deleteAll': 'Delete all',
  'notifications.toggleDetails.more': 'View more details',
  'notifications.toggleDetails.less': 'View less details',
  'notifications.fileGenerated': 'Generated file',
  'notifications.remove': 'Remove notification',
  'notifications.taskNumber': 'Task number',
  'notifications.taskTitle': 'Task title',
  'notifications.listName': 'List',
  'notifications.entityName': 'Entity',
  'notifications.company': 'Company',
  'notifications.environment': 'Environment',
  'notifications.message': 'Message',
  'notifications.operation': 'Operation',
  'notifications.operation.export': 'EXPORT',
  'notifications.operation.import': 'IMPORT',
  'notifications.operation.purge': 'PURGE',
  'notifications.status': 'Status',
  'notifications.fileName': 'File',
  'notifications.fileSize': 'Size',
  'notifications.expiration': 'Expires',
  'notifications.company': 'Company',
  'notifications.environment': 'Environment',
  'notifications.processInstanceName': 'Request',
  'notifications.time': 'Time',
  'notifications.loadingMore': 'Loading more notifications...',
  'notifications.endOfList': 'No more notifications',
  'notifications.processInstanceId': 'Instance',
  'notifications.processEvents.generic.label': 'Process event',
  'notifications.processEvents.generic.cta': 'View request',
  'notifications.processEvents.newTaskAssigned.label': 'New task assigned',
  'notifications.processEvents.newTaskAssigned.cta': 'Open request',
  'notifications.processEvents.newTaskAssigned.title': 'New task assigned',
  'notifications.processEvents.newTaskAssigned.body': 'A new task was assigned to your inbox.',
  'notifications.processEvents.newComment.label': 'New comment',
  'notifications.processEvents.newComment.cta': 'View comment',
  'notifications.processEvents.newComment.title': 'New comment',
  'notifications.processEvents.newComment.body': 'You received a new comment in your request.',
  'notifications.processEvents.newComment.creator': 'Author',
  'notifications.processEvents.newComment.date': 'Comment date',
  'notifications.processEvents.newComment.comment': 'Comment',
  'notifications.processEvents.newComment.attachments': 'Attachments',
  'notifications.category.entity': 'Entity',
  'notifications.category.list': 'List',
  'notifications.category.process': 'Process',
  'notifications.category.task': 'Task',
  'notifications.category.comment': 'Comment',
  'notifications.category.chat': 'Chat',
  'notifications.category.bulk': 'Bulk',
  'notifications.category.alert': 'Alert',
  'notifications.category.system': 'System',

  // Status values
  'notifications.status.completed': 'Completed',
  'notifications.status.failed': 'Failed',
  'notifications.status.inProgress': 'In Progress',
  'notifications.status.queued': 'Queued',
  'notifications.status.cancelled': 'Cancelled',
  'notifications.status.skipped': 'Skipped',
  'notifications.status.unknown': 'Unknown',

  // Priority levels
  'notifications.priority.high': 'High',
  'notifications.priority.normal': 'Normal',
  'notifications.priority.low': 'Low',

  // Entity export notifications
  'notifications.export.completed.title': 'Export completed',
  'notifications.export.completed.message':
    'The export of "{entityName}" has been completed successfully',
  'notifications.export.failed.title': 'Export failed',
  'notifications.export.failed.message': 'The export of "{entityName}" has failed',
  'notifications.export.inprogress.title': 'Export in progress',
  'notifications.export.inprogress.message': 'The export of "{entityName}" is being processed',
  'notifications.export.queued.title': 'Export queued',
  'notifications.export.queued.message': 'The export of "{entityName}" is queued for processing',

  // Entity import notifications
  'notifications.import.completed.title': 'Import completed',
  'notifications.import.completed.message':
    'The import of "{entityName}" has been completed successfully',
  'notifications.import.failed.title': 'Import failed',
  'notifications.import.failed.message': 'The import of "{entityName}" has failed',
  'notifications.import.inprogress.title': 'Import in progress',
  'notifications.import.inprogress.message': 'The import of "{entityName}" is being processed',

  // Operations text
  'notifications.operationType.export': 'Export',
  'notifications.operationType.import': 'Import',
  'notifications.operationType.default': 'Operation',

  // Status text
  'notifications.statusText.pending': 'Queued',
  'notifications.statusText.processing': 'In Progress',
  'notifications.statusText.processed': 'Completed',
  'notifications.statusText.failed': 'Failed',
  'notifications.statusText.error': 'Error',
  'notifications.statusText.cancelled': 'Cancelled',
  'notifications.statusText.skipped': 'Skipped',
  'notifications.statusText.unknown': 'Unknown',

  // Generic notifications
  'notifications.generic.title': 'New notification',
  'notifications.generic.message': 'A new notification has been received',

  // Actions
  'notifications.action.download': 'Download file',
  'notifications.action.view': 'View details',
  'notifications.action.retry': 'Retry',

  // Messages
  'notifications.download.success': 'Download started successfully',
  'notifications.download.error': 'Error downloading file',

  // File messages
  'notifications.file.expires': 'Expires',

  // List export notifications
  'notifications.list.export.completed.title': 'List export completed',
  'notifications.list.export.completed.message':
    'The export of list "{listName}" has been completed successfully',
  'notifications.list.export.failed.title': 'List export failed',
  'notifications.list.export.failed.message': 'The export of list "{listName}" has failed',
  'notifications.list.export.inprogress.title': 'List export in progress',
  'notifications.list.export.inprogress.message':
    'The export of list "{listName}" is being processed',
  'notifications.list.export.queued.title': 'List export queued',
  'notifications.list.export.queued.message':
    'The export of list "{listName}" is queued for processing',

  // List import notifications
  'notifications.list.import.completed.title': 'List import completed',
  'notifications.list.import.completed.message':
    'The import of list "{listName}" has been completed successfully',
  'notifications.list.import.failed.title': 'List import failed',
  'notifications.list.import.failed.message': 'The import of list "{listName}" has failed',
  'notifications.list.import.inprogress.title': 'List import in progress',
  'notifications.list.import.inprogress.message':
    'The import of list "{listName}" is being processed',

  // Report export notifications
  'notifications.report.export.completed.title': 'Report export completed',
  'notifications.report.export.completed.message':
    'The export of report "{reportName}" has been completed successfully',
  'notifications.report.export.failed.title': 'Report export failed',
  'notifications.report.export.failed.message': 'The export of report "{reportName}" has failed',
  'notifications.report.export.failed.messageDetail':
    'The export of report "{reportName}" has failed: {observations}',
  'notifications.report.export.inprogress.title': 'Report export in progress',
  'notifications.report.export.inprogress.message':
    'The export of report "{reportName}" is being processed',
  'notifications.report.export.queued.title': 'Report export queued',
  'notifications.report.export.queued.message':
    'The export of report "{reportName}" is queued for processing',
  'notifications.report.export.cancelled.title': 'Report export cancelled',
  'notifications.report.export.cancelled.message':
    'The export of report "{reportName}" has been cancelled',

  'notifications.category.report': 'Report',

  // Chat notifications
  'notifications.chat.newMessageTitle': 'New message from {userName}',
  'notifications.chat.previewFallback': 'You received a new support chat message.',
  'notifications.chat.senderFallback': 'Automy',
  'notifications.chat.threadLabel': 'New message',
  'notifications.chat.openThread': 'Open chat',
  'notifications.chat.threadId': 'Thread ID',
  'notifications.chat.lastUpdate': 'Last update',
  'notifications.chat.status.pending': 'Pending',
  'notifications.chat.status.active': 'Active',
  'notifications.chat.status.lookingForAgent': 'Looking for agent',
  'notifications.chat.status.closed': 'Closed',
  'notifications.chat.status.archived': 'Archived',
};
